import { ExtendedRequestInfoSafe } from '../types'

const CACHED_REDIRECT_ENVELOPE_HEADER = 'X-Cached-Redirect-Envelope'

/**
 * Same scope as Os-App-Version / shouldAddOsAppVersionHeader: only requests whose
 * URL is under window.API_BASE_URL.
 */
function isOsApiRequestUrl(url: string): boolean {
  return url.startsWith(window.API_BASE_URL || '')
}

/**
 * Opts into the JSON envelope for cached PDF hits on our API (see Django
 * generate_pdf_worker). Same URL scope as Os-App-Version — only OS API requests.
 */
export const cachedRedirectEnvelopeReqMiddleware = async (req: Request, options: ExtendedRequestInfoSafe) => {
  if (isOsApiRequestUrl(req.url) && !options.headers.has(CACHED_REDIRECT_ENVELOPE_HEADER)) {
    options.headers.set(CACHED_REDIRECT_ENVELOPE_HEADER, 'true')
  }
}
